import React from 'react';


function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>
      <p className="loading-text">Loading...</p>
    </div>
  );
}

export default Loader;
